import './servicesCard.css'
  //will probably migrate the Links here to separate button components
function servicesCard(props) {
  return(
    <div className="servicesCardDiv">
      <img src={props.filepath} style={{overflow: "hidden", height: "25vw", width: "25vw", borderRadius: "20px"}}/>
      <p style={{justifyContent:"center",height:"10vh",fontSize:"24pt"}}>{props.service}</p>
    </div>
  )
}

export default servicesCard